import { Box, Flex } from '@chakra-ui/react';
import React from 'react';

export const FundingRequestSideColumn = ({
  ButtonRow,
  FundingRequestInfoBox,
}: {
  ButtonRow: React.ReactElement;
  FundingRequestInfoBox: React.ReactElement | null;
}) => {
  const borderWidth = FundingRequestInfoBox !== null ? '1px' : '0px';
  return (
    <Flex m={2} direction="column" justify="space-between" w="350px" h="750px">
      <Box borderWidth={borderWidth} justifyContent="normal">
        {FundingRequestInfoBox}
      </Box>
      <Box ml="auto">{ButtonRow}</Box>
    </Flex>
  );
};
